const RegionData = class{
  constructor() {
    this.$parent = document.querySelector('.as-region-selector')

    // 源数据
    this.$zoneData = document.querySelector('.as-zones-data')
    this.$regionData = document.querySelector('.as-regions-data')
    this.$localesData = document.querySelector('.as-selector-config-data')
    this.$settingsData = document.querySelector('.as-customize-app-settings-data')
    
    if (!this.$parent || !this.$regionData) return
    this.$data = {}
    this.$settings = {}
    this.$showModal = false
    
    this.$stores = this.$parent.querySelector('.as-stores-wrap')
    this.$selectedRegionCookie = 'selectedRegion'
    this.$host = window.location.host
    this.$path = window.location.pathname

    this.$targetRegion = {}

    this.$selectorModal = this.$parent.querySelector('.as-selector-modal')
    this.$selectorDropdown = this.$parent.querySelector('.as-selector-dropdown')
    this.init()
  }
  init() {
    this.handleMetaData()
    this.initSelectorStatus()
  }
  handleMetaData() {
    // 初始化数据
    this.$data.areas = this.$zoneData && JSON.parse(this.$zoneData.innerHTML)
    this.$data.regions = this.$regionData && JSON.parse(this.$regionData.innerHTML)
    const initLocales = JSON.stringify(
      {
        locales: []
      }
    )
    this.$data.locales = JSON.parse(this.$localesData && JSON.parse(this.$localesData.innerHTML).find(item => item.configType === 2)?.content || initLocales)?.locales
    this.$settings = this.$settingsData && JSON.parse(this.$settingsData.innerHTML).settings

    if (this.$path.length > 1) {
      this.$data.regions.map(item => {
        if (item.websiteUrl.endsWith('/')) {
          item.websiteUrl = item.websiteUrl + this.$path?.substring(1)
        } else {
          item.websiteUrl = item.websiteUrl + this.$path
        }
      })
    }
    this.$data.areas.map(item => {
      item.regions = this.$data.regions.filter(regionItem => regionItem.zoneId === item.id)
    })
  }
  initSelectorStatus() {
    if (this.$settings && !this.$settings.enableSelector) {
      this.$parent.remove()
      return
    } else {
      this.$parent.classList.remove('d-none')
    }
    this.initStyle()
    // 渲染页脚展示的国家和国旗
    this.renderSelectedStore()
    // 对数据排序
    this.sortRegionList()
    this.renderCopyWritting()
    this.renderRegionList()
    // 国旗，国家等配置
    this.initOtherSettings()
    this.initSelector()
  }
  initStyle() {
    this.$parent.style.backgroundColor = this.$settings?.selectorBg
    this.$parent.style.color = this.$settings?.selectorText
    if (this.$settings && this.$settings.selectorDropdown) {
      this.$wrap = this.$selectorDropdown
      this.$selectorDropdown.classList.remove('d-none')
      this.$selectorModal.remove()
      this.$stores.style.backgroundColor = this.$settings?.selectorBg
      // 颜色等样式处理
    } else {
      this.$wrap = this.$selectorModal
      this.$selectorModal.classList.remove('d-none')
      this.$selectorDropdown.remove()
      this.$showModal = true
      // 弹窗背景色处理
      this.$wrap.classList.add(this.$settings?.selectorModalStyle)
    }
  }
  sortRegionList() {
    if (this.$showModal && this.$settings?.showArea) {
      this.$data.areas.map((item) => {
        item.regions?.sort(this.sortData('name'))
      })
    }
    this.$data.regions.sort(this.sortData('name'))
  }
  sortData(property) {
    return function (a, b) {
      if (a[property] > b[property]) {
        return 1
      }
      if (a[property] < b[property]) {
        return -1
      }
      return 0
    }
  }
  renderCopyWritting() {
    if (!this.$showModal) return
    let targetLocale = this.$data.locales.find(item => item.isoCode == this.$targetRegion?.languageIsoCode)
    // 渲染弹窗标题
    targetLocale && (targetLocale.title) && (this.$wrap.querySelector('.as-modal-title').textContent = targetLocale?.title)
  }
  renderRegionList() {
    if (this.$showModal) {
      // 渲染弹窗数据
      if (this.$settings?.showArea) {
        this.$data.areas.map((item, index) => {
          let newNode = document.createElement('div')
          let areaHtml =  this.$parent.querySelector('.as-modal-list-with-area-template').innerHTML.replace(/#{area}/g, item.name).replace(/#{index}/g, index)
          newNode.innerHTML = areaHtml
          // let collapseBtn = newNode.querySelector('.as-collapse-btn')
          // let collapseContent = newNode.querySelector('.as-collapse-content')
          // collapseBtn.dataset.bsTarget = `selector-${index}`
          // collapseContent.id = `selector-${index}`
          let regionWrap = newNode.querySelector('.as-regions-wrap')
          item.regions?.map(item => {
            var wrapper= document.createElement('li');
            wrapper.classList.add('col')
            let regionHtml = this.$parent.querySelector('.as-region-list-template').innerHTML.replace('#{url}', item.websiteUrl).replace('#{region}', item.localName || item.name).replace('#{language}', item.languageLocalName || item.languageName).replace(/#{isoCode}/g, item.isoCode.toUpperCase())
            wrapper.innerHTML = regionHtml
            regionWrap.appendChild(wrapper)
          })
          this.$wrap.querySelector('.as-modal-region-list-with-region').appendChild(newNode)   
        })
        this.initCollapse()
      } else {
        this.$data.regions.map((item) => {
          let newNode = document.createElement('li')
          newNode.classList.add('col')
          let listHtmlTemplate =  this.$parent.querySelector('.as-region-list-template').innerHTML
          let newHtml = listHtmlTemplate.replace('#{url}', item.websiteUrl).replace('#{region}', item.localName || item.name).replace('#{url}', item.websiteUrl).replace('#{language}', item.languageLocalName || item.languageName).replace(/#{isoCode}/g, item.isoCode.toUpperCase())
          newNode.innerHTML = newHtml
          this.$wrap.querySelector('.as-modal-region-list-without-region').appendChild(newNode)
        })
      } 
    } else {
      // 渲染下拉数据(多语言处理)
      let dropdownLists = this.$parent.querySelector('.as-dropdown-lists')
      if (!dropdownLists) return
      this.$data.regions.map((item) => {
        let newNode = document.createElement('li')
        let listHtmlTemplate =  this.$parent.querySelector('.as-list-html').innerHTML
        let newHtml = listHtmlTemplate.replace('#{url}', item.websiteUrl).replace('#{region}', item.localName || item.name).replace('#{language}', item.languageLocalName || item.languageName).replace(/#{isoCode}/g, item.isoCode.toUpperCase())
        newNode.innerHTML = newHtml
        dropdownLists.appendChild(newNode)
      })
    }
  }
  initCollapse() {
    let collapseBtn = this.$parent.querySelectorAll('.as-collapse-btn')
    collapseBtn.forEach((item) => {
      item.addEventListener('click', (event) => {
        item.classList.toggle('collapsed')
        item.ariaExpanded == 'true' ? (item.ariaExpanded = 'false') : (item.ariaExpanded = 'true')
        // setTimeout(() => {
        //   item.nextElementSibling.classList.remove('collapsing')
        //   item.nextElementSibling.classList.add('collapse')
        //   item.nextElementSibling.classList.toggle("show")
        // }, 350);
        // item.nextElementSibling.classList.add('collapsing')
        // item.nextElementSibling.classList.remove('collapse')
        item.nextElementSibling.classList.toggle("show")
      })
    })
  }
  getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
  }
  renderSelectedStore() {
    let $selectedRegion = this.$wrap.querySelector('.as-selected-store')
    let $selectedLanguage = this.$wrap.querySelector('.as-selected-language')
    let $selectedFlag= this.$wrap.querySelector('.as-featured-flag')
    
    let showCookieTarget
    let cookieTarget
    if (this.getCookie(this.$selectedRegionCookie)) {
      cookieTarget = this.$data.regions.find(item => item.isoCode.toUpperCase() == this.getCookie(this.$selectedRegionCookie))
      if (cookieTarget) {
        try {
          new URL(cookieTarget.websiteUrl)?.host == this.$host ? showCookieTarget = true : showCookieTarget = false
        }
        catch(error) {
          showCookieTarget = false
        }
      }
    }
    if (showCookieTarget) {
      this.$targetRegion = cookieTarget
    } else {
      try {
        this.$targetRegion = this.$data.regions.filter(item => new URL(item.websiteUrl)?.host == this.$host).find(item => item.isRecommended) || this.$data.regions.find(item => new URL(item.websiteUrl)?.host == this.$host) || this.$data.regions.find(item => item.isRecommended)
      }
      catch(error) {
        this.$targetRegion = this.$data.regions.find(item => item.isRecommended)
      }
    }
    $selectedRegion.textContent= this.$targetRegion?.localName || this.$targetRegion?.name
    $selectedLanguage.textContent= `( ${this.$targetRegion?.languageLocalName || this.$targetRegion?.languageName} )`
    $selectedFlag.classList.add(`sc-${this.$targetRegion?.isoCode.toUpperCase()}`)
  }
  initOtherSettings() {
    if (!this.$settings?.showLanguage) {
      this.$parent.classList.add('no-language')
    }
    if (!this.$settings?.showFlag) {
      this.$parent.classList.add('use-default-flag')
    }
  }
  initSelector() {
    this.$storeItem = this.$parent.querySelectorAll('.as-store')
    Array.from(this.$storeItem).map((item) => {
      item.addEventListener('click', () => {
        if (document.domain.split('.').slice(-2).join('.') !== 'myshopify.com') {
          document.cookie=`${this.$selectedRegionCookie}=${item.dataset.regionCode};path=/;domain=${document.domain.split('.').slice(-2).join('.')}`
        } else {
          document.cookie=`${this.$selectedRegionCookie}=${item.dataset.regionCode};path=/`
        }
      })
    })
  }

}
new RegionData()
